import { Field } from "formik";
import LoadingField from "./LoadingField";
import InputGroupForm from "./InputGroupForm";
import ErrorFieldForm from "./ErrorFieldForm";
export default function RegionField({
    label,
    name,
    loading,
    loadingText,
    options,
    placeholder,
    onChange,
}) {
    if (loading) {
        return <LoadingField text={loadingText} />;
    }

    return (
        <InputGroupForm label={label}>
            <Field name={name}>
                {({ field }) => (
                    <select
                        {...field}
                        className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-blue-300"
                        onChange={(e) => {
                            field.onChange(e);
                            onChange?.(e.target.value);
                        }}
                    >
                        <option value="">{placeholder}</option>

                        {options.map((item) => (
                            <option key={item.id} value={item.name}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                )}
            </Field>

            <ErrorFieldForm name={name} />
        </InputGroupForm>
    );
}